import withParams from "@src/components/widgets/HOC/withParams";
import React, { useState } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetPlayPacmanParams } from "../interface";
import LandingPacman, {
  IPacmanGameData,
} from "design-system/src/Components/WidgetPart/LandingPacman/LandingPacman";
import { PacmanGameId } from "@src/components/widgets/hooks/useCtaAction";
import GameParticipationModal from "../Components/GameParticipationModal/GameParticipationModal";
import { useTranslation } from "@src/hooks/useTranslation";

const LandingStandardPlayPacman: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetPlayPacmanParams>((props) => {
    const { p } = props;
    const [gameData, setGameData] = useState<IPacmanGameData | undefined>(
      undefined
    );
    const { t } = useTranslation(["Pacman"]);

    const handleOnFinished = (data: IPacmanGameData) => {
      setGameData(data);
    };
    return (
      <div id={PacmanGameId} style={{ overflow: "hidden" }}>
        <LandingPacman
          url={p("game_url") || ""}
          poster={{
            desktop: p("poster_desktop") + "",
            mobile: p("poster_mobile") + "",
          }}
          onFinished={handleOnFinished}
          playLabel={t("Jouer", "Pacman")}
          title={p("title") || ""}
          highlightedTitle={p("subtitle") || ""}
          description={p("description") || ""}
        />
        <GameParticipationModal
          data={gameData}
          onCancel={() => setGameData(undefined)}
        />
      </div>
    );
  });

export default LandingStandardPlayPacman;
